var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#CCC",
    width: 30,
    height: 30,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    opacity: 0.4,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.403 8.331a11.021 11.021 0 016.558 1.627.087.087 0 00.122-.116c-.148-.26-.308-.515-.478-.762a10.11 10.11 0 00-6.753-4.264 10.889 10.889 0 00-5.978 5.857.087.087 0 00.134.103 11.93 11.93 0 016.395-2.445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.144 15.013a10.865 10.865 0 014.972-5.333.087.087 0 00-.037-.163c-.306-.007-.612 0-.916.023-2.74.25-5.265 1.59-7.008 3.717-.473 2.902.27 5.87 2.053 8.207a.087.087 0 00.155-.066 11.999 11.999 0 01.78-6.385zM22.483 14.735a11.47 11.47 0 01-5.023 5.42.087.087 0 00.043.163 9.976 9.976 0 001.59-.122 10.582 10.582 0 006.507-3.718 10.69 10.69 0 00-2.087-8.125.087.087 0 00-.155.066 11.447 11.447 0 01-.875 6.316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.617 8.368a11.686 11.686 0 012.073 6.792.087.087 0 00.161.047 10.13 10.13 0 00.718-8.845 10.645 10.645 0 00-8.02-2.228.087.087 0 00-.02.167 11.272 11.272 0 015.088 4.067zM19.3 21.414c-.59.093-1.187.14-1.785.14a11.065 11.065 0 01-5.952-1.775.087.087 0 00-.124.115c.198.356.42.698.661 1.026a10.808 10.808 0 006.777 4.113 10.887 10.887 0 005.987-5.878.087.087 0 00-.134-.102 12.024 12.024 0 01-5.43 2.361z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.123 21.668a10.855 10.855 0 01-2.149-6.966.087.087 0 00-.162-.049c-.158.261-.303.53-.435.806a10.261 10.261 0 00-.264 7.929 10.696 10.696 0 008.138 2.303.087.087 0 00.019-.167 11.99 11.99 0 01-5.147-3.856z"
  })))));
}
export default SvgNoLogo;